import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Image from '../../../components/Image';
import { addToOrder } from "../../../redux/actions/orderActions";
import {
  selectItem,
  loadMenuItemSupplements,
  loadBusinessLunchInfo,
} from "../../../redux/actions/menuActions";
import FormattedPrice from "../../../components/FormattedPrice";
import IPosModal from "../../../IPosModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTranslation } from "react-i18next";
import { getImageName } from "../../../api/iposApi";
import { DeliveryType } from "../../../constants/deliveryTypes";
import {
  hideLoading,
  showLoading,
} from "../../../redux/actions/loadingActions";
import { useHistory, useParams } from "react-router-dom";
import { MenuPresentationTypes } from "../../../constants/menuPresentationTypes";
//import { generateOrderItem } from "../../../helpers/common";

const MenuItem = ({
  menuItem,
  addToOrder,
  t,
  selectedItem,
  selectedItemSupplements,
  loadMenuItemSupplements,
  loadBusinessLunchInfo,
  selectedBusinessLunch,
  currentLanguageId,
  selectItem,
  menuItemTypes,
  currentDeliveryType,
  showLoading,
  hideLoading,
  branchInfo,
  menuPresentation,
  orderItems,
}) => {
  const history = useHistory();
  const { branchId } = useParams();

  const inCartItems = orderItems.filter(
    (item) => item.menuItem.menu_item_id === menuItem.menu_item_id
  );
  const isInCart = orderItems.find(
    (item) => item.menuItem.menu_item_id === menuItem.menu_item_id
  );

  const validateSaleAbility = () => {

    if (!isSalesTime(menuItem.start_sales, menuItem.end_sales)) {      
      return [false, t("sale_blocks.sales_block_by_time")];
    }

    if (
      !menuItem.block_sales_in_site ||
      menuItem.block_sales_in_site === "000"
    ) {
      return [true, ""];
    }

    // '000' - Delivery, TA, Eat-in
    if (currentDeliveryType === DeliveryType.EAT_IN) {
      if (menuItem.block_sales_in_site.charAt(2) === "1") {
        return [false, t("sale_blocks.eat_in_sale_prohibited")];
      }
    }

    if (currentDeliveryType === DeliveryType.DELIVERY) {
      if (menuItem.block_sales_in_site.charAt(0) === "1") {
        return [false, t("sale_blocks.delivery_sale_prohibited")];
      }
    }

    if (currentDeliveryType === DeliveryType.TA) {
      if (menuItem.block_sales_in_site.charAt(1) === "1") {
        return [false, t("sale_blocks.ta_sale_prohibited")];
      }
    }    

    return [true, ""];
  };

  const now = new Date();

  const parseDotNetDate = (value) => {
    if (!value) return null;
  
    const match = value.match(/\d+/);
    return match ? new Date(Number(match[0])) : null;
  };

  const isSalesTime = (startSales, endSales) => {
    if (!startSales || !endSales) {
      return true;
    }

    const start = new Date(parseDotNetDate(startSales));
    const end = new Date(parseDotNetDate(endSales));

    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    const startMinutes = start.getHours() * 60 + start.getMinutes();
    const endMinutes = end.getHours() * 60 + end.getMinutes();

    return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
  };

  const addItemToCart = async (e) => {
    if (currentDeliveryType === DeliveryType.MENU) {
      e.preventDefault();
      return;
    }

    e.preventDefault();

    const [valid, message] = validateSaleAbility();

    if (!valid) {      
      IPosModal.alert({
        title: "",
        message: message,
        okButtonText: t("buttons.ok"),
        onOk: () => {
          return;
        },
      });
      return;
    }        

    let itemMessage = null;
    let webImageName = null;
    branchInfo.MessagesInfo.forEach((message) => {
      const item = message.item_relations.find(
        (i) => i.menu_item_id === menuItem.menu_item_id
      );
      if (item && message.web_image_name_txt) {
        webImageName = message.web_image_name_txt;
      }
      else if (item && message.message_txt) {
        itemMessage = message.message_txt;
      }
    });    
   
    if (webImageName) {
      await showMenuImageMessage(webImageName);
    }
    else if (itemMessage) {
      await showMenuItemMessage(itemMessage);
    }

    selectItem(menuItem);

    const isBusinessLunch = menuItem.is_business_lunch_flg === 1 || menuItem.is_kiosk_item_flg === 1;
        
    if (isBusinessLunch)
    {
       loadBusinessLunchInfo(menuItem.menu_item_id).then((blData) => {
         openAddBLItemModal(menuItem.menu_item_id, blData);
       });
    }
    else 
    {
      loadMenuItemSupplements(menuItem.menu_item_id).then(([supplements, instructions]) => {
        openAddItemModal(supplements, instructions);        
      });
    }   
  };

  const showMenuItemMessage = (itemMessage) => {
    return new Promise((resolve) => {
      IPosModal.alert({
        title: "",
        message: itemMessage,
        okButtonText: t("buttons.ok"),
        onOk: () => {
          resolve();
        },
      });
    });
  };

  const showMenuImageMessage = (imageName) => {
    return new Promise((resolve) => {
      IPosModal.adImageModal({
        imagePath: imageName,
        onOk: () => {
          resolve();
        },
      });
    });
  };

  const openAddItemModal = (supplements, instructions) => {
    IPosModal.addItemModal(
      {
        menuItem: menuItem,
        t: t,
        //isRtl: currentLanguageId === 2,
        selectedItemSupplements: supplements,
        itemInstructions: instructions,
        menuItemTypes: menuItemTypes,
        currentLanguageId,
        branchInfo,
        onOk: (orderItem) => {
          addToOrder(orderItem);
        },
        onClose: () => {},
      },
      {}
    );
  };

  const openAddBLItemModal = async (businessLunchId, blData) => {
    //await loadBusinessLunchInfo(businessLunchId).then((blData) => {
      IPosModal.testModal(
        {
          menuItem: menuItem,
          selectedBusinessLunch: blData,
          loadMenuItemSupplements: loadMenuItemSupplements,          
          currentLanguageId: currentLanguageId,
          branchInfo: branchInfo,
          menuItemTypes: menuItemTypes,
          t,
          onOk: (orderItem) => {
            addToOrder(orderItem);
          },
        },
        {}
      );
    //});
  }; 
  
  const renderInCartBlock = () => {
    const inCartItemsQuantity = inCartItems.reduce((acc, item) => {
      return acc + item.orderItem.quantity;
    }, 0);

    return (
      <div className="in-cart-block">
        <div className={"quantity-in-cart"}>{inCartItemsQuantity}</div>
      </div>
    );
  };

  if (menuPresentation === MenuPresentationTypes.Thumb) {
    return (
      <li
        className={`${branchInfo.use_two_column ? "col-md-6 col-sm-6 col-xs-6" : "col-md-4 col-sm-4 col-xs-4" } item product ${menuPresentation}-item ${
          isInCart ? "in-cart" : ""
        }`}
        id={`menu-item-${menuItem.menu_item_id}`}
        onClick={addItemToCart}
      >
        <div className="container-inner clearfix">
          {isInCart && renderInCartBlock()}

          <div className="product-info">
            <Image image={getImageName(branchInfo, menuItem)} useDefaultEmpty = {true} />

            <div className="product-detail">
              <div className={"product-detail-header"}>
                <h2 className="product-name">{menuItem.item_name}</h2>

                <p className="product-description">
                  {currentLanguageId === 2
                    ? menuItem.details_txt
                    : menuItem.details_eng_txt}
                </p>

                <div className="price-box">
                  <span className="product-price">
                    <FormattedPrice price={menuItem.web_price} />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  }

  return (
    <li
      className={`${branchInfo.use_two_column ? "col-md-6 col-sm-6" : "col-md-4 col-sm-4" } item product ${menuPresentation}-item ${
        isInCart ? "in-cart" : ""
      }`}
      id={`menu-item-${menuItem.menu_item_id}`}
      onClick={addItemToCart}
    >
      <div className="container-inner clearfix">
        {isInCart && renderInCartBlock()}

        <div className="product-info">
          <Image image={getImageName(branchInfo, menuItem)} useDefaultEmpty = {true} />

          <div className="product-detail">
            <div className={"product-detail-header"}>
              <h2 className="product-name">{menuItem.item_name}</h2>

              <div className="price-box text-center">
                <span className="product-price">
                  <FormattedPrice price={menuItem.web_price} />
                </span>
              </div>
            </div>

            <p className="product-description">
              {currentLanguageId === 2
                ? menuItem.details_txt
                : menuItem.details_eng_txt}
            </p>
          </div>
        </div>
        {/* {currentDeliveryType !== DeliveryType.MENU && (
          <div className={"add-to-cart-btn"}>
            <FontAwesomeIcon icon="plus-circle" />
          </div>
        )} */}
      </div>
    </li>
  );
};

const mapStateToProps = (state) => {
  const {
    menuGroups,
    selectedBusinessLunch,
    selectedItemSupplements,
    selectedItem,
    menuItemTypes,
    currentLanguageId,
    currentDeliveryType,
    branchInfo,
    orderItems,
    menuPresentation,
  } = state;

  return {
    menuGroups,
    selectedBusinessLunch,
    selectedItemSupplements,
    selectedItem,
    menuItemTypes,
    currentLanguageId,
    currentDeliveryType,
    branchInfo,
    orderItems,
    menuPresentation,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      addToOrder,
      selectItem,
      showLoading,
      hideLoading,
      loadMenuItemSupplements,
      loadBusinessLunchInfo,
    },
    dispatch
  );

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(MenuItem)
);
